import style from './index.module.scss';

export default function Loading() {
  return (
    <div className={style['loading-overlay']}>
      <div className={style['loading-spinner']} />
    </div>
  );
}
